import { createContext, useContext, useEffect, useState } from "react";
import { startTranslator } from "@/i18n/translator";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (en) => en });

const initialLang = () => {
  const p = window.location.pathname;
  return p === "/fr" || p.startsWith("/fr/") ? "fr" : "en";
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);
  document.documentElement.lang = lang;

  const setLang = (l) => {
    localStorage.setItem("dp_lang", l);
    setLangState(l);
  };

  useEffect(() => {
    if (lang !== "fr") return undefined;
    return startTranslator();
  }, [lang]);

  const t = (en, fr) => (lang === "fr" ? fr : en);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div key={lang}>{children}</div>
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
